// @ts-check

/**
 * Mapbox label layer utilities.
 * Handles finding label layers for proper layer insertion.
 */

/**
 * Find the first label layer in the map style.
 * This is typically used to insert custom layers beneath labels.
 * @see {@link https://docs.mapbox.com/mapbox-gl-js/example/geojson-layer-in-stack/}
 * @param {import('mapbox-gl').Map} map - Mapbox map instance
 * @returns {string|undefined} The ID of the first label layer, or undefined if none found
 */
export function findFirstLabelLayer(map) {
  if (!map) return undefined;

  try {
    const layers = map.getStyle().layers;
    // Find the first symbol layer (which typically contains labels)
    const labelLayer = layers.find((layer) => layer.type === "symbol");
    return labelLayer ? labelLayer.id : undefined;
  } catch (error) {
    console.warn("Error finding first label layer:", error);
    return undefined;
  }
}
